import * as React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import BarChartIcon from '@mui/icons-material/BarChart';
import NextWeekIcon from '@mui/icons-material/NextWeek';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import BusinessIcon from '@mui/icons-material/Business';
import PaymentsIcon from '@mui/icons-material/Payments';
import PaidIcon from '@mui/icons-material/Paid';
import {FormatListBulleted} from '@mui/icons-material';
import EuroIcon from '@mui/icons-material/Euro';
import StorageIcon from '@mui/icons-material/Storage';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import LinkIcon from '@mui/icons-material/Link';
import HistoryIcon from '@mui/icons-material/History';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import ArticleIcon from '@mui/icons-material/Article';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';

import {Link as RouterLink, useLocation} from 'react-router-dom'
import {AclRouterLink} from "./ACL";
import helpers from "../helpers/common";
import {useEffect, useState} from "react";
import projects from "../models/projects";
import useRootHook from "../hooks/useRoot";

export const MainListItems = () => {
    const {forcedMerchantID, userData} = useRootHook()
    const location = useLocation()

    const isActive = (to) => {
        if (to === '/') return location.pathname === '/'
        return location.pathname === to || location.pathname.startsWith(`${to}/`)
    }

    const navItemSx = (selected, disabled) => ({
        mx: 1,
        my: 0.25,
        borderRadius: 2,
        px: 1.5,
        py: 0.75,
        color: selected ? 'text.primary' : 'text.secondary',
        ...(selected
            ? {
                bgcolor: 'rgba(99, 91, 255, 0.08)',
                '& .MuiListItemIcon-root': { color: 'primary.main' },
              }
            : {
                '&:hover': { bgcolor: 'rgba(10, 37, 64, 0.04)' },
              }),
        ...(disabled ? { opacity: 0.5 } : null),
    })

    const iconSx = {
        minWidth: 36,
        color: 'text.secondary',
        '& svg': { fontSize: 20 },
    }

    // For referrals, show only Dashboard
    if (userData?.role === helpers.roles.R) {
        return <React.Fragment>
            <ListSubheader
                component="div"
                disableSticky
                sx={{ px: 3, pt: 2, pb: 0.5, lineHeight: 1.6 }}
            >
                Overview
            </ListSubheader>
            <ListItemButton to="/" underline="none" selected={isActive('/')} component={RouterLink} sx={navItemSx(isActive('/'), false)}>
                <ListItemIcon sx={iconSx}>
                    <DashboardIcon/>
                </ListItemIcon>
                <ListItemText primary="Dashboard"/>
            </ListItemButton>
            <ListItemButton to="/tickets" underline="none" selected={isActive('/tickets')} component={AclRouterLink} sx={navItemSx(isActive('/tickets'), false)}>
                <ListItemIcon sx={iconSx}>
                    <ConfirmationNumberIcon/>
                </ListItemIcon>
                <ListItemText primary="Support tickets"/>
            </ListItemButton>
        </React.Fragment>
    }

    return <React.Fragment>
        <ListSubheader
            component="div"
            disableSticky
            sx={{ px: 3, pt: 2, pb: 0.5, lineHeight: 1.6 }}
        >
            Overview
        </ListSubheader>
        <ListItemButton to="/" underline="none" selected={isActive('/')} component={RouterLink} sx={navItemSx(isActive('/'), false)}>
            <ListItemIcon sx={iconSx}>
                <DashboardIcon/>
            </ListItemIcon>
            <ListItemText primary="Dashboard"/>
        </ListItemButton>
        <ListItemButton to="/stats" underline="none" selected={isActive('/stats')} component={AclRouterLink} sx={navItemSx(isActive('/stats'), false)}>
            <ListItemIcon sx={iconSx}>
                <StorageIcon/>
            </ListItemIcon>
            <ListItemText primary="Stats"/>
        </ListItemButton>
        <ListItemButton to="/action-logs" underline="none" forceRoles={[helpers.roles.A, helpers.roles.S]} selected={isActive('/action-logs')} component={AclRouterLink} sx={navItemSx(isActive('/action-logs'), false)}>
            <ListItemIcon sx={iconSx}>
                <HistoryIcon/>
            </ListItemIcon>
            <ListItemText primary="Логи действий"/>
        </ListItemButton>
        <ListItemButton to="/payment-page-opens" underline="none" forceRoles={[helpers.roles.A, helpers.roles.S]} selected={isActive('/payment-page-opens')} component={AclRouterLink} sx={navItemSx(isActive('/payment-page-opens'), false)}>
            <ListItemIcon sx={iconSx}>
                <LinkIcon/>
            </ListItemIcon>
            <ListItemText primary="Открытия страницы оплаты"/>
        </ListItemButton>

        <ListSubheader
            component="div"
            disableSticky
            sx={{ px: 3, pt: 2, pb: 0.5, lineHeight: 1.6 }}
        >
            Atlas
        </ListSubheader>
        <ListItemButton to="/atlas/traffic" underline="none" selected={isActive('/atlas/traffic')} component={AclRouterLink} sx={navItemSx(isActive('/atlas/traffic'), false)}>
            <ListItemIcon sx={iconSx}>
                <AltRouteIcon/>
            </ListItemIcon>
            <ListItemText primary="Traffic"/>
        </ListItemButton>

        <ListSubheader
            component="div"
            disableSticky
            sx={{ px: 3, pt: 2, pb: 0.5, lineHeight: 1.6 }}
        >
            Business
        </ListSubheader>
        <ListItemButton to="/merchants" underline="none" disabled={!!forcedMerchantID} selected={isActive('/merchants')} component={AclRouterLink} sx={navItemSx(isActive('/merchants'), !!forcedMerchantID)}>
            <ListItemIcon sx={iconSx}>
                <BusinessIcon/>
            </ListItemIcon>
            <ListItemText primary="Merchants"/>
        </ListItemButton>
        <ListItemButton to="/projects" underline="none" selected={isActive('/projects')} component={AclRouterLink} sx={navItemSx(isActive('/projects'), false)}>
            <ListItemIcon sx={iconSx}>
                <BusinessCenterIcon/>
            </ListItemIcon>
            <ListItemText primary="Projects"/>
        </ListItemButton>
        <ListItemButton to="/customers" underline="none" selected={isActive('/customers')} component={AclRouterLink} sx={navItemSx(isActive('/customers'), false)}>
            <ListItemIcon sx={iconSx}>
                <PeopleIcon/>
            </ListItemIcon>
            <ListItemText primary="Customers"/>
        </ListItemButton>

        <ListSubheader
            component="div"
            disableSticky
            sx={{ px: 3, pt: 2, pb: 0.5, lineHeight: 1.6 }}
        >
            Payments
        </ListSubheader>
        <ListItemButton to="/transactions" underline="none" selected={isActive('/transactions')} component={AclRouterLink} sx={navItemSx(isActive('/transactions'), false)}>
            <ListItemIcon sx={iconSx}>
                <FormatListBulleted/>
            </ListItemIcon>
            <ListItemText primary="Transactions"/>
        </ListItemButton>
        <ListItemButton to="/paymethods" underline="none" color="inherit" disabled={!!forcedMerchantID} selected={isActive('/paymethods')} component={AclRouterLink} sx={navItemSx(isActive('/paymethods'), !!forcedMerchantID)}>
            <ListItemIcon sx={iconSx}>
                <PaymentsIcon/>
            </ListItemIcon>
            <ListItemText primary="Methods"/>
        </ListItemButton>
        {[helpers.roles.A, helpers.roles.S].includes(userData?.role) && (
            <ListItemButton to="/limits" underline="none" disabled={!!forcedMerchantID} selected={isActive('/limits')} component={AclRouterLink} sx={navItemSx(isActive('/limits'), !!forcedMerchantID)} forceRoles={[helpers.roles.A, helpers.roles.S]}>
                <ListItemIcon sx={iconSx}>
                    <BarChartIcon/>
                </ListItemIcon>
                <ListItemText primary="Limits"/>
            </ListItemButton>
        )}
        <ListItemButton to="/payouts" underline="none" selected={isActive('/payouts')} component={AclRouterLink} sx={navItemSx(isActive('/payouts'), false)}>
            <ListItemIcon sx={iconSx}>
                <PaidIcon/>
            </ListItemIcon>
            <ListItemText primary="Payouts"/>
        </ListItemButton>

        <ListSubheader
            component="div"
            disableSticky
            sx={{ px: 3, pt: 2, pb: 0.5, lineHeight: 1.6 }}
        >
            Settings
        </ListSubheader>
        <ListItemButton to="/currencies" underline="none"
                        forceRoles={[helpers.roles.A, helpers.roles.S]} disabled={!!forcedMerchantID} selected={isActive('/currencies')} component={AclRouterLink} sx={navItemSx(isActive('/currencies'), !!forcedMerchantID)}>
            <ListItemIcon sx={iconSx}>
                <EuroIcon/>
            </ListItemIcon>
            <ListItemText primary="Currencies"/>
        </ListItemButton>
        <ListItemButton
            to="/payment-domains"
            underline="none"
            forceRoles={[helpers.roles.A, helpers.roles.S]}
            disabled={!!forcedMerchantID}
            selected={isActive('/payment-domains')}
            component={AclRouterLink}
            sx={navItemSx(isActive('/payment-domains'), !!forcedMerchantID)}
        >
            <ListItemIcon sx={iconSx}>
                <LinkIcon/>
            </ListItemIcon>
            <ListItemText primary="Payment domains"/>
        </ListItemButton>
        <ListItemButton to="/servers" underline="none" disabled={!!forcedMerchantID} selected={isActive('/servers')} component={AclRouterLink} sx={navItemSx(isActive('/servers'), !!forcedMerchantID)}>
            <ListItemIcon sx={iconSx}>
                <BarChartIcon/>
            </ListItemIcon>
            <ListItemText primary="Servers"/>
        </ListItemButton>
        <ListItemButton to="/admins" underline="none" forceRoles={[helpers.roles.S]} disabled={!!forcedMerchantID} selected={isActive('/admins')} component={AclRouterLink} sx={navItemSx(isActive('/admins'), !!forcedMerchantID)}>
            <ListItemIcon sx={iconSx}>
                <AdminPanelSettingsIcon/>
            </ListItemIcon>
            <ListItemText primary="Admins"/>
        </ListItemButton>
        {[helpers.roles.A, helpers.roles.S].includes(userData?.role) && (
            <ListItemButton to="/referrals" underline="none" disabled={!!forcedMerchantID} selected={isActive('/referrals')} component={AclRouterLink} sx={navItemSx(isActive('/referrals'), !!forcedMerchantID)}>
                <ListItemIcon sx={iconSx}>
                    <AccountTreeIcon/>
                </ListItemIcon>
                <ListItemText primary="Referrals"/>
            </ListItemButton>
        )}
        {[helpers.roles.A, helpers.roles.S].includes(userData?.role) && (
            <ListItemButton to="/news" underline="none" disabled={!!forcedMerchantID} selected={isActive('/news')} component={AclRouterLink} sx={navItemSx(isActive('/news'), !!forcedMerchantID)}>
                <ListItemIcon sx={iconSx}>
                    <ArticleIcon/>
                </ListItemIcon>
                <ListItemText primary="News"/>
            </ListItemButton>
        )}
        <ListItemButton to="/tickets" underline="none" selected={isActive('/tickets')} component={AclRouterLink} sx={navItemSx(isActive('/tickets'), false)}>
            <ListItemIcon sx={iconSx}>
                <ConfirmationNumberIcon/>
            </ListItemIcon>
            <ListItemText primary="Support tickets"/>
        </ListItemButton>
    </React.Fragment>
}

export const SecondaryListItems = () => {
    const [projectsData, setProjectsData] = useState([])
    useEffect(() => {
        projects.index().then((data) => {
            data && data.projects && setProjectsData(data.projects)
        })
    }, [])

    if (!projectsData) return null

    return <React.Fragment>
        <ListSubheader component="div" inset>
            Projects
        </ListSubheader>
        {projectsData.map((project, key) => {
            if (key > 4) return null
            return <ListItemButton key={project.uuid} underline="none" color="inherit" to={`/projects?${project.uuid}`} component={AclRouterLink}>
                <ListItemIcon>
                    <NextWeekIcon/>
                </ListItemIcon>
                <ListItemText primary={`${project.name}`}/>
            </ListItemButton>
        })}
    </React.Fragment>
}